module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-summary bgWhite px-1"
  }, [_c('div', {
    staticClass: "wrapper-summary d-flex flex-column"
  }, [_c('p', {
    staticClass: "title-summary"
  }, [_vm._v("Resumen de tu compra")]), _vm._v(" "), _c('section', {
    staticClass: "pt-3 pb-1 px-3 fontS14"
  }, [_c('div', {
    staticClass: "d-flex space-between mb-1"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("SubTotal")]), _vm._v(" "), _c('p', {
    staticClass: "m0"
  }, [_vm._v(" " + _vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.getTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Envío")]), _vm._v(" "), _c('p', {
    staticClass: "m0"
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.shippingCostAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Descuento")]), _vm._v(" "), _c('p', {
    staticClass: "m0"
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm.getClientDiscount))])])]), _vm._v(" "), _c('section', {
    staticClass: "px-3 d-flex space-between fontS16"
  }, [_c('p', [_vm._v("Total")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.total)))])]), _vm._v(" "), _c('section', {
    staticClass: "container-button px-1 flex-95"
  }, [_c('div', {
    staticClass: "d-flex justify-center"
  }, [(_vm.routeName === 'payment') ? _c('button', {
    class: [
      'btn-box',
      'uppercase',
      'btn-responsive',
      {
        'btn-disabled': _vm.invalidOrder
      } ],
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:1px solid " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button",
      "disabled": _vm.invalidOrder
    },
    on: {
      "click": function($event) {
        _vm.makeOrder()
      }
    }
  }, [_vm._v("Pagar")]) : (_vm.routeName === 'buy-car') ? _c('button', {
    class: [
      'btn-box uppercase',
      {
        'btn-disabled': _vm.totalProducts < 1
      } ],
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:1px solid " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button",
      "disabled": _vm.totalProducts < 1
    },
    on: {
      "click": _vm.payAction
    }
  }, [_vm._v("Pasar a caja")]) : _c('button', {
    class: [
      'uppercase',
      'btn-box',
      'btn-responsive',
      {
        'btn-disabled': _vm.invalidPaymentMethod
      } ],
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:1px solid " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button",
      "disabled": _vm.invalidPaymentMethod
    },
    on: {
      "click": function($event) {
        _vm.makeOrder(true)
      }
    }
  }, [_vm._v("Finalizar Compra")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06fe9f96","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchaseSummary.vue
// module id = 1066
// module chunks = 29